import * as THREE from 'node_modules/three/build/three.module.js';
import { Vector3 } from 'three';
import { BoothModel, FBX } from '../models';
import {
  StateService
} from 'src/app/services';
import { TweenMax } from 'gsap';
import boothData from '../data/booths.json';
export class EnvironmentFBX {

  public degRad: number = 0.0174532925;
  public _fbx: FBX = undefined;
  public scale: any = { x: 10, y: 10, z: 10 };
  public _parent: any = undefined;
  public bArrowsVisible: any = undefined;
  public navArrows: Array<any> = [];  // These are the brand nav arrows.
  public backArrow: any = undefined;   // Back arrow from brands...
  public tweens: Array<any> = [];
  public backArrowTween: any = null;
  ;
  constructor(
    public fbx: FBX,
    private parentRef: any,
    private stateSvc: StateService,
    private boothData: BoothModel
  ) {
    this._fbx = fbx;
    this._parent = parentRef
  }

  public handleStateChange(nState: any): void {
    this.hideBackButton();
    switch (nState) {
      case this.stateSvc.states.CENTER:
        // Nav arrows to go forward.
        this.aniNavArrows();

        break;

      default:
        this.aniNavArrows(false);
        if (nState > this.stateSvc.states.CENTER && !this.stateSvc.ONE_BOOTH_SHOW) {
          this.rotateBackButton(nState);
        } else {

        }

        // Turn on all booth lights.
        // this.dirLight.target = this.booths[0];
        // this.lights.moveLights(this.stateSvc.getLookatCoords());
        break;
    }
    //
  }

  public aniNavArrows(bIn: Boolean = true): void {
    let small: any = { x: 0, y: 0, z: 0, ease: "elastic.in(1, 0.3)" };
    // const big: any = { x: this.scale.x, y: this.scale.y, z: this.scale.z, delay: 2, ease: "elastic.out(1, 0.3)" };
    // const big: any = { x: this.scale.x, y: this.scale.y, z: this.scale.z, delay: 2, ease: 'expo.out' };
    this.bArrowsVisible = bIn;
    let ctn = 0;
    this.killTweens();
    if (bIn) {
      this.navArrows.forEach(obj => {
        small = { x: 0, y: 0, z: 0 };
        const big: any = { x: this.scale.x, y: this.scale.y, z: this.scale.z, delay: (2 + .25 * ctn), ease: "elastic.out(1, 0.3)" };
        this.tweens.push(TweenMax.fromTo(obj.scale, 1, small, big));

      });
      setTimeout(() => {
        this.pulseArrow();
      }, 2500);
    } else {
      // TweenMax.killDelayedCallsTo(this.pulseArrow);
      this.navArrows.forEach(obj => {
        // TweenMax.killTweensOf(obj);
        this.tweens.push(TweenMax.to(obj.scale, 1, small));
      });
    }
  }

  public killTweens() {
    while (this.tweens.length > 0) {
      let t = this.tweens.pop();
      t.kill();
    }
  }

  public pulseArrow(): void {
    if (!this.bArrowsVisible) {
      return;
    }
    this.navArrows.forEach(obj => {
      this.pulseArrowBig(obj);
    });

  }
  public pulseArrowSmall(obj): void {
    if (!this.bArrowsVisible) {
      return;
    }
    // const big: any = { x: this.scale.x, y: this.scale.y, z: this.scale.z, ease: 'expo.in' };
    const big: any = { x: this.scale.x, y: this.scale.y, z: this.scale.z, yoyo: true, repeat: -1 };
    this.tweens.push(TweenMax.to(obj.scale, 1, big));
  }

  public pulseArrowBig(obj): void {
    //Depricated.
    if (!this.bArrowsVisible) {
      return;
    }
    const pulse: any = { x: 12, y: 12, z: 12, onComplete: this.pulseArrowSmall.bind(this), onCompleteParams: [obj] };
    TweenMax.to(obj.scale, 1, pulse);
  }


  public createIcons(iconFBX: FBX): void {
    // console.log("createIcons", iconFBX, this._parent);

    for (const booth of this.boothData.booths) {
      if (booth.fbx) {
        const newObj = iconFBX.fbx.clone();
        const v3 = this.stateSvc.getCoordinatesById(booth.id, 700);
        newObj.name = '' + booth.id;
        newObj.rotation.x = Math.PI / 2;
        newObj.rotation.z = -this.stateSvc.getBoothRotation(booth.id) * this.degRad;
        newObj.position.x = v3.x;
        newObj.position.z = v3.z;
        newObj.position.y = 20;
        newObj.scale.set(this.scale.x, this.scale.y, this.scale.z);
        newObj.castShadow = false;
        newObj.receiveShadow = true;
        this._parent.add(newObj);
        this.navArrows.push(newObj);
      }
    }

    this.createBackButton(iconFBX);
  }

  public rotateBackButton(id) {
    const big: any = { x: 8, y: 8, z: 8, delay: (2), ease: "elastic.out(1, 0.3)", onComplete: this.pulseBackBig.bind(this), onCompleteParams: [this.backArrow] };
    const v3 = this.stateSvc.getCoordinatesById(id, 1150);

    this.backArrow.position.x = v3.x;
    this.backArrow.position.z = v3.z;
    // this.backArrow.position.y = 20;
    this.backArrowTween = TweenMax.to(this.backArrow.scale, 1, big)
    this.backArrow.rotation.z = -this.stateSvc.getBoothRotation(id) * this.degRad + Math.PI;

  }

  public pulseBackSmall(obj): void {
    return;
    // const big: any = { x: this.scale.x, y: this.scale.y, z: this.scale.z, ease: 'expo.in' };
    const big: any = { x: 8, y: 8, z: 8, onComplete: this.pulseBackBig.bind(this), onCompleteParams: [obj] };
    this.backArrowTween = TweenMax.to(obj.scale, 1, big);
  }

  public pulseBackBig(obj): void {
    const pulse: any = { x: 10, y: 10, z: 10, yoyo: true, repeat: -1, onComplete: this.pulseBackSmall.bind(this), onCompleteParams: [obj] };
    this.backArrowTween = TweenMax.to(obj.scale, 1, pulse);
  }

  public hideBackButton() {
    if (this.backArrowTween) {
      this.backArrowTween.kill();
    }

    if (this.backArrow.scale.x != 0) {
      const big: any = { x: 0, y: 0, z: 0, ease: "elastic.in(1, 0.3)" };
      TweenMax.to(this.backArrow.scale, .4, big)
    }
  }

  public createBackButton(iconFBX): void {
    this.backArrow = iconFBX.fbx.clone();
    // const v3 = this.stateSvc.getCoordinatesById(boothData.booths[i].id, 700);
    this.backArrow.name = 'BackFromBrand';
    this.backArrow.rotation.x = Math.PI / 2;
    this.backArrow.position.y = 20;
    this.backArrow.scale.set(this.scale.x, this.scale.y, this.scale.z);
    this.backArrow.castShadow = true;
    this.backArrow.receiveShadow = true;
    console.log('this.backArrow', this.backArrow)
    this._parent.add(this.backArrow);
  }

  public get position(): Vector3 {
    return this._fbx.fbx.position;
  }
  public set position(pos: Vector3) {
    this._fbx.fbx.position = pos;
  }

  public get rotation(): Vector3 {
    return this._fbx.fbx.rotation;
  }
  public set rotation(rot: Vector3) {
    this._fbx.fbx.rotation = rot;
  }


}
